import { useState } from 'react';

import constate from 'constate';

import { useUserContext } from './UserContext';

function useAnnouncements() {
    const { user } = useUserContext();

    const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);

    const openSidePanel = () => setIsSidePanelOpen(true);
    const closeSidePanel = () => setIsSidePanelOpen(false);

    return {
        isSidePanelOpen,
        openSidePanel,
        closeSidePanel,
        creationEnabled: !!user?.features?.announcementsCreationEnabled,
    };
}

const [AnnouncementsContextProvider, useAnnouncementsContext] = constate(useAnnouncements);

export { AnnouncementsContextProvider, useAnnouncementsContext };
